import React, { useMemo, useState } from "react";
import { Box, Dialog, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DynamicForm from "../create/DynamicForm";

/**
 * 양식 미리보기 — 직원이 상신할 때 보게 될 화면을 그대로 띄운다.
 *
 * <p>상신 화면과 <b>같은 컴포넌트</b>({@link DynamicForm})를 쓴다. 미리보기를 따로 그리면
 * 실제 화면과 조금씩 달라지고, 그러면 미리보기로 확인한 게 아무 의미가 없어진다.
 *
 * <p>보이는 건 편집 중인 <b>초안</b> 기준이다. 아직 발행 전이라 직원 화면은 이전 내용을 쓰고 있다 —
 * 그래서 위에 그 사실을 적어 둔다.
 */
export default function FormPreviewModal({ open, onClose, form, fields, notice, myInfo }) {
    const [values, setValues] = useState({});

    // DynamicForm 은 상신 화면의 양식 객체 모양을 기대한다 — 편집 중인 초안으로 그 모양을 만든다.
    const asForm = useMemo(() => ({
        code: form?.code,
        name: form?.name,
        notice,
        fields: fields || [],
    }), [form, fields, notice]);

    const context = useMemo(
        () => ({ myInfo, projectChannels: [], refApprovals: [] }),
        [myInfo]
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth={false} fullWidth
                PaperProps={{ sx: { width: "72vw", maxWidth: 900, height: "88vh", overflow: "hidden" } }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between"
                   sx={{ px: 2, py: 1.25, borderBottom: "1px solid #e2e8f0" }}>
                <Box>
                    <Typography sx={{ fontSize: 14, fontWeight: 800 }}>미리보기 — {form?.name}</Typography>
                    <Typography sx={{ fontSize: 11.5, color: "#94a3b8" }}>
                        편집 중인 초안입니다. 발행해야 직원 화면에 적용됩니다.
                    </Typography>
                </Box>
                <IconButton size="small" onClick={onClose}><CloseRoundedIcon sx={{ fontSize: 20 }} /></IconButton>
            </Stack>

            <Box sx={{ flex: 1, overflowY: "auto", p: 2.5, bgcolor: "#f8fafc" }}>
                <Box sx={{ bgcolor: "#fff", borderRadius: 2, border: "1px solid #e2e8f0", p: 2.5 }}>
                    <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 1.5 }}>{form?.name}</Typography>
                    <TextField
                        size="small" fullWidth disabled
                        placeholder="제목 (비우면 양식 이름으로 자동 생성)"
                        sx={{ mb: 2 }}
                        InputProps={{ sx: { fontSize: 13 } }}
                    />
                    <DynamicForm form={asForm} values={values} onChange={setValues} context={context} />

                    {(fields || []).length === 0 && (
                        <Typography sx={{ fontSize: 12.5, color: "#94a3b8", py: 4, textAlign: "center" }}>
                            입력칸이 없습니다.
                        </Typography>
                    )}
                </Box>

                <Typography sx={{ fontSize: 11.5, color: "#94a3b8", mt: 1.5 }}>
                    · 실제로 입력해 볼 수 있지만 저장되지 않습니다.
                    · 거래처·프로젝트 같은 목록은 미리보기에서 비어 있습니다.
                    · 결재선과 열람자는 상신하는 사람에 따라 달라져 여기서는 보여주지 않습니다.
                </Typography>
            </Box>
        </Dialog>
    );
}
